import { useEffect, useRef, useState } from "react";
import { StatusHistory } from "../../../types/services.type";
import { getFormattedDate } from "../../../helpers/serviceHelpers";
import {
  Box,
  Stack,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";

export default function ComplaintStatus({
  statusHistory,
}: {
  statusHistory: StatusHistory[];
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentStep((x) => x + 1);
      if (currentStep >= statusHistory.length - 1) {
        clearInterval(intervalRef.current);
      }
    }, 100);

    return () => {
      clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Stack>
      <Typography variant="h6">Status History</Typography>
      <Box sx={{ p: 1, pt: 2 }}>
        <Stepper activeStep={currentStep} orientation="vertical">
          {statusHistory.map((step, index) => (
            <Step expanded key={step.status_name}>
              <StepLabel>
                <Typography variant="caption">{`${getFormattedDate(
                  step.status_date
                )} • ${step.status_time.slice(0, 5)}`}</Typography>
              </StepLabel>
              <StepContent>
                <Typography>{step.status_name}</Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Stack>
  );
}
